/**
 * i18n Configuration
 * Konfiguration för internationalisering med react-i18next
 * Översättningar lagras i filer för enkel versionering och hantering
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { translationsSv } from './locales/sv';
import { translationsEn } from './locales/en';
import { translationsLt } from './locales/lt';

// Initiera i18n med översättningar från filer
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      sv: {
        translation: translationsSv,
      },
      en: {
        translation: translationsEn,
      },
      lt: {
        translation: translationsLt,
      },
    },
    fallbackLng: 'sv',
    lng: localStorage.getItem('i18nextLng') || 'sv',
    debug: import.meta.env.MODE === 'development',
    react: {
      useSuspense: false, // Viktigt för att undvika problem med async loading
    },
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage'], // Använd endast localStorage, inte navigator
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      // Ignorera webbläsarens språk - vi vill bara använda localStorage eller fallback
    },
  });

export default i18n;

